// utils/favicon.js
// Swaps the browser favicon at runtime to the admin-uploaded site icon. Points
// EVERY existing icon link from index.html (icon, shortcut icon, 48x48 png,
// apple-touch-icon) at the dynamic URL so the admin icon reliably wins in the
// tab regardless of which size the browser prefers. When no admin icon is set
// this is a no-op and the stable /public fallback (Google-crawlable) stays.
//
// Pass an already cache-busted URL (e.g. `${url}?v=${updatedAt}`); if `url`
// is empty/missing this is a no-op and the default favicon stays in place.
export const setFavicon = (url) => {
    if (!url || typeof document === 'undefined') return
    try {
        const head = document.head
        // rel~='icon' covers rel="icon" and rel="shortcut icon"; apple-touch is separate.
        const links = head.querySelectorAll(
            "link[rel~='icon'], link[rel='shortcut icon'], link[rel='apple-touch-icon']"
        )
        if (!links.length) {
            const link = document.createElement('link')
            link.rel = 'icon'
            link.href = url
            head.appendChild(link)
            return
        }
        links.forEach((link) => {
            if (link.getAttribute('href') !== url) link.setAttribute('href', url)
        })
    } catch (_) {
        // never let favicon swapping break the app
    }
}

// Builds a cache-busted icon URL from a public site-settings payload.
// Prefers favicon.url, falls back to siteIcon.url. Returns '' when none.
export const resolveSiteIconUrl = (settings) => {
    if (!settings) return ''
    const url = settings?.favicon?.url || settings?.siteIcon?.url || ''
    if (!url) return ''
    const stamp = settings?.updatedAt ? new Date(settings.updatedAt).getTime() : null
    if (!stamp) return url
    return url.includes('?') ? `${url}&v=${stamp}` : `${url}?v=${stamp}`
}

export default setFavicon
